import { SvgIcon, SvgIconProps } from '@mui/material';
import { ReactComponent } from './uplift-icon.svg';


export const UpliftIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} component={ReactComponent} viewBox="0 0 72 36" />
);
